import { login, getUserInfo } from '@/api/sys'
import { setItem, getItem, removeAllItem } from '@/utils/storage'
import { TOKEN, PERSONAL_LOGIN_STATUS } from '@/constant'
import { setTimeStamp } from '@/utils/auth'
import router, { resetRouter } from '@/router'

// import { shallowRef } from 'vue'

export default {
  namespaced: true,
  state: () => ({
    token: getItem(TOKEN) || '',
    userInfo: {},
    isPersonalLogin: getItem(PERSONAL_LOGIN_STATUS) === 'true' || getItem(PERSONAL_LOGIN_STATUS) === true || false
  }),
  mutations: {
    setToken (state, token) {
      state.token = token
      setItem(TOKEN, token)
    },
    setUserInfo (state, userInfo) {
      console.log('setUserInfo:', userInfo)
      state.userInfo = userInfo
    },
    setPersonalLoginStatus (state, status) {
      state.isPersonalLogin = status
      setItem(PERSONAL_LOGIN_STATUS, status)
    }
  },
  actions: {
    login (context, userInfo) {
      const { username, password } = userInfo
      return new Promise((resolve, reject) => {
        login({
          username,
          password: password
        }).then(data => {
          this.commit('user/setToken', data.data)
          setTimeStamp()
          resolve(data.data)
        }).catch(error => reject(error))
      })
    },
    // 个人登录
    personalLogin (context, userInfo) {
      const { username, password } = userInfo
      return new Promise((resolve, reject) => {
        // 导入个人登录API
        import('@/api/personal').then(({ personalLogin }) => {
          personalLogin({
            username,
            password
          }).then(response => {
            if (response.code === 200) {
              // 设置token
              this.commit('user/setToken', response.data.accessToken)
              // 设置个人登录状态
              this.commit('user/setPersonalLoginStatus', true)
              // 为个人登录设置基本用户信息，避免触发getUserInfo请求
              this.commit('user/setUserInfo', {
                userId: 'personal_user',
                username: username,
                loginType: 'personal',
                isPersonalLogin: true
              })
              // 设置token时间戳
              setTimeStamp()
              resolve(response.data)
            } else {
              reject(new Error(response.error || '登录失败'))
            }
          }).catch(error => reject(error))
        })
      })
    },
    async getUserInfo (context) {
      const userInfo = await getUserInfo()
      this.commit('user/setUserInfo', userInfo.data)
      return userInfo.data
    },
    logout () {
      resetRouter()
      this.commit('user/setToken', '')
      this.commit('user/setUserInfo', {})
      this.commit('user/setPersonalLoginStatus', false)
      removeAllItem()
      router.push('/')
    }
  }
}
